<script>
export default {
  name: "NoticeMessage",
  data() {
    return {}
  },
  methods: {
    getNotice() {
      this.$router.push('/abouts/notice');
    }
  }
};
</script>

<template>
  <div class="notice-message" @click="getNotice">
    <img src="@/assets/images/nav-notice-icon.png" class="icon">
    <!-- <div class="num-tip">{{ 11 }}</div> -->
  </div>
</template>

<style lang="scss" scoped>


.notice-message{
  position: relative;
  width: 27px;
  height: 27px;
  cursor: pointer;

  .icon {
    width: 100%;
    height: 100%;
  }

  .num-tip {
    position: absolute;
    top: -4px;
    right: -4px;
    color: #FFFFFF;
    background: #e34248;
    font-size: 10px;
    border-radius: 7px;
    padding: 1px 2px;
  }
}

</style>
